//Change in Cart
function updateQuantity(line,quantity) {
  $.ajax({
      type: 'POST',
      url: '/cart/change',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
        
      },
    });
}
$(document).ready(function() {
  //$('.cv--atc').click(function(e){
   $(document).off('click', '.cv--atc').on('click', '.cv--atc', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); 
   $(".loading__spinner").removeClass("hidden");
    $(".path").addClass("btnpath");
    var data = $(this).parents('form').serialize();
    var qty = 1;
    $.ajax({
      type: 'POST',
      url: '/cart/add',
      data: data,
      dataType: 'html',
      success: function(response){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
          // debugger
          handleFloCartBtn()
          var carttext =cart.item_count;
          jQuery("#cart-count-item").text(carttext);
          });
         $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        //  $('.cart__drawer').html($(response).filter('.cart__drawer').html()).addClass('show-cart__drawer');
        // $('.cart__drawer').addClass('show-cart__drawer');
        // $('body').addClass('cv--show-cart__drawer');
        $('.cross').click(function(){
          $('.cart__drawer').removeClass('show-cart__drawer');
        });
        $(".loading__spinner").addClass("hidden");
      }
    });
  });
});

$(document).ready(function() {

  // Cart Drawer Open On Click Cart Icon
  $(document).on("click",".site-header__cart", function(e) {
    e.preventDefault();
    $('.cart__drawer').addClass('show-cart__drawer');
    $('body').addClass('cv--show-cart__drawer');
   // console.log('codevibez');
  });
  // Cart Drawer Close On Click cross Icon
  $(document).on("click",".cross",function() {
    $('.cart__drawer').removeClass('show-cart__drawer');
    $('body').removeClass('cv--show-cart__drawer');
  });
//   Close Cart Drawer click anywhere
  $(document).mouseup(function(e){
    var container = $(".cart__drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.show();
      $('.cart__drawer').removeClass('show-cart__drawer');
      $('body').removeClass('cv--show-cart__drawer');
    }
  });
  
});
$(document).ready(function() {
  // Remove Item from Cart
  $(document).on("click",".cart__remove",function(e) {
    e.preventDefault();
    var itemUrl = $(this).attr('href');
    $(".loading__spinner").removeClass("hidden");
    $(".qty-loader").addClass("hidloader");
    $.ajax({
      url: itemUrl,
      type:'GET',
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        $('.cart__drawer').html($(response).filter('.cart__drawer').html()); 
        $(".loading__spinner").addClass("hidden");
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext =cart.item_count;
          jQuery("#cart-count-item").text(carttext);
        });
       }
    });
  });
});
// Change In Quantity Selector
$(document).ready(function() {

  //$(document).on("click",".plus",function() {
  $(document).off("click", ".plus").on("click", ".plus", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $(this).prev().val(+$(this).prev().val() + 1);
    var data =  $(this).parents('form').serialize();
    //console.log(data);
    var quantity = $(this).prev().val();
    updateQuantity(data,quantity);
    var datalines = $(this).attr('dataline');
    $('#shoppingLoader-'+datalines).load(datalines).html('<span><img src="https://cdn.shopify.com/s/files/1/0789/3480/2738/files/1488.gif?v=1708601542" width="20"/></span>');
    $.ajax({
      type: 'POST',
      url: '/cart/update',
      data: data,
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        $('.cart__drawer').html($(response).filter('.cart__drawer').html());
       jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext =cart.item_count;
          jQuery("#cart-count-item").text(carttext);
        });
      }
    });

  });

  //$(document).on("click",".minus",function() {
  $(document).off("click", ".minus").on("click", ".minus", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if ($(this).next().val() > 0) {
      $(this).next().val(+$(this).next().val() - 1);
      var data =  $(this).parents('form').serialize();
      var quantity = $(this).next().val();
      updateQuantity(data,quantity);
     var datalines = $(this).attr('dataline');
     $('#shoppingLoader-'+datalines).load(datalines).html('<span><img src="https://cdn.shopify.com/s/files/1/0789/3480/2738/files/1488.gif?v=1708601542" width="20"/></span>');
      $.ajax({
        type: 'POST',
        url: '/cart/update',
        data: data,
        dataType: 'html',
        success: function(response){
          $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
          $('.cart__drawer').html($(response).filter('.cart__drawer').html());
          jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext =cart.item_count;
          jQuery("#cart-count-item").text(carttext);
        });
        }
      });
    }
  });
});
//Count Section on cart header
jQuery.getJSON('/cart.js', function (cart, textStatus) {
  var carttext =cart.item_count;
  var cartCount=jQuery("#cart-count-item").text(carttext);
});

//Test Loader on loading
jQuery.getJSON('/cart.js', function(){
$(".chk-btn").click(function(){
  $(".loading__spinner").removeClass("hidden");
});
});

//<!--Start test of debug quantity--->
 /*$('.item-qty').on('change', function() {
  var variantId = $(this).data('variant-id'); // comes from HTML attribute
  var newQty = $(this).val();

  jQuery.post('/cart/update.js', {
    updates: {
      [variantId]: newQty
    }
  }, function(cart) {
    $('#cart-count-item').text(cart.item_count);
  }, 'json');
});*/
//<!--End test of debug quantity--->





